import React from "react";
import classNames from "classnames";
import { HEADER_HEIGHT } from "@app/styles/layout-vars";
import { ReportNavigationProps } from "./types";
import classes from "./report-navigation.module.scss";

export const ReportNavigation = ({ sections, onItemClick }: ReportNavigationProps) => {
    const handleClick = (id: string) => {
        const el = document.getElementById(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
            window.scrollTo({ top, behavior: "smooth" });
        }
        if (onItemClick) onItemClick();
    };

    return (
        <ul className={classes["report-nav"]}>
            {sections.map(({ id, label, status }) => (
                <li
                    className={classes["report-nav__item"]}
                    key={id}
                    onClick={() => handleClick(id)}
                >
                    <span
                        className={classNames(classes["report-nav__dot"], {
                            [classes["report-nav__dot--ok"]]: status === "ok",
                            [classes["report-nav__dot--warn"]]: status === "warning"
                        })}
                    />
                    {label}
                </li>
            ))}
        </ul>
    );
};